import { atom, useAtom } from "jotai";

const isGuidedTourModalOpenAtom = atom<boolean>(false);

export const useToogleGuidedTourModal = () => {
  const [isGuidedTourModalOpen, setIsGuidedTourModalOpen] = useAtom(isGuidedTourModalOpenAtom);
  return { isGuidedTourModalOpen, setIsGuidedTourModalOpen };
};
